<template>
  <div>
    <b-row class="mb-1">
      <b-col>
        <strong>{{ trans(type + '_participants') }}</strong>
      </b-col>
      <b-col v-if="showDelete" class="col-auto">
        <b-button variant="link" size="sm" class="text-danger" @click="onClickDelete">
          <i class="fa fa-fw fa-times"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-form-group>
      <b-form-radio-group v-model="what" :options="whatOptions" :disabled="busy">
      </b-form-radio-group>
    </b-form-group>
    <b-form-group v-if="!!all_classes">
      <class-multiselect
        v-if="what == 'classes'"
        :organization="organization"
        v-model="am_class_ids"
        :all-classes="all_classes"
        @all-classes="all_classes = $event; $emit('all-classes', $event)"
        :all-tags="all_tags"
        @all-tags="all_tags = $event; $emit('all-tags', $event)"
        @participant-count="classes_participant_count = $event"
        @class-count="classes_class_count = $event"
        requestOnTagsChange
      ></class-multiselect>
      <class-tags-multiselect
        v-if="what == 'classes_with_tags'"
        :organization="organization"
        v-model="tags"
        :all-classes="all_classes"
        @all-classes="all_classes = $event; $emit('all-classes', $event)"
        @participant-count="classes_with_tags_participant_count = $event"
        @class-count="classes_with_tags_class_count = $event"
      ></class-tags-multiselect>
      <b-form-text v-if="what == 'classes_with_tags' && !!tags && tags.length > 1">
        {{ trans('in_classes_with_tags_warning') }}
      </b-form-text>
    </b-form-group>
    <p v-if="!busy && participantCount !== null && classCount !== null">
      {{ participantCount }}
      {{ trans('participant' + (participantCount > 1 || participantCount  == 0 && lang == 'en' ? 's' : '')).toLowerCase() }}
      {{ trans('in') }}
      {{ classCount }}
      {{ trans('class' + (classCount > 1 || classCount  == 0 && lang == 'en' ? 'es' : '')).toLowerCase() }}
    </p>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </div>
</template>

<script>
  import ClassMultiselect from './../class/ClassMultiselect'
  import ClassTagsMultiselect from './../class/ClassTagsMultiselect'

  const blank = {
    name: null,
    type: 'add',
    what: 'classes',
    am_class_ids: null,
    tags: null,
    participant_count: null,
    class_count: null,
    participants: [],
  }

  export default {
    props: {
      organization: Object,
      recipient_list: Object,
      allClasses: Array,
      allTags: Array,
      value: Object,
      showDelete: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      ClassMultiselect,
      ClassTagsMultiselect,
    },
    data() {
      let rule = this.value ? _.cloneDeep(this.value) : _.clone(blank)
      return {
        trans: trans,
        lang: lang,
        busy: false,
        error: null,
        all_classes: this.allClasses,
        all_tags: this.allTags,
        name: rule.name,
        type: rule.type,
        what: rule.what,
        am_class_ids: rule.am_class_ids,
        tags: rule.tags,
        whatOptions: [
          {value: 'classes', text: trans('in_classes')},
          {value: 'classes_with_tags', text: trans('in_classes_with_tags')},
        ],
        classes_participant_count: rule.what == 'classes' ? rule.participant_count : null,
        classes_class_count: rule.what == 'classes' ? rule.class_count : null,
        classes_with_tags_participant_count: rule.what == 'classes_with_tags' ? rule.participant_count : null,
        classes_with_tags_class_count: rule.what == 'classes_with_tags' ? rule.class_count : null,
        participants: [],
        last_participants_loaded_rule: null,
      }
    },
    computed: {
      participantCount() {
        if (!!this.participants) return this.participants.length
        return this.what == 'classes' ? this.classes_participant_count : this.classes_with_tags_participant_count
      },
      classCount() {
        return this.what == 'classes' ? this. classes_class_count : this.classes_with_tags_class_count
      },
      serialized() {
        return {
          name: this.name,
          type: this.type,
          what: this.what,
          am_class_ids: this.am_class_ids,
          tags: this.tags,
          participant_count: this.participantCount,
          class_count: this.classCount,
          participants: this.participants
        }
      },
    },
    watch: {
      allClasses() {
        this.all_classes = this.allClasses
      },
      allTags() {
        this.all_tags = this.allTags
      },
      value() {
        let rule = this.value ? _.cloneDeep(this.value) : _.clone(blank)
        this.name = rule.name
        this.type = rule.type
        this.what = rule.what
        this.am_class_ids = rule.am_class_ids
        this.tags = rule.tags
        this.loadParticipants()
      },
      serialized() {
        if (!_.isEqual(_.omit(this.value, 'participants'), _.omit(this.serialized, 'participants')))
          this.$emit('input', this.serialized)
      },
    },
    methods: {
      onClickDelete() {
        this.$emit('delete')
      },
      loadClasses() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/event/ll`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.all_classes = response.data
          this.$emit('all-classes', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      loadParticipants() {
        let serialized = _.omit(this.serialized, 'participants')
        if (this.last_participants_loaded_rule &&
          _.isEqual(serialized, this.last_participants_loaded_rule))
          return
        this.last_participants_loaded_rule = serialized
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/list/${this.recipient_list.id}/class_participants`
        return axios.post(url, serialized)
        .then(response => {
          this.busy = false
          this.participants = response.data.participants
          this.$emit('input', this.serialized)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      }
    },
    mounted() {
      window.classParticipantRule = this
      if (this.all_classes == null) {
        this.loadClasses().then(this.loadParticipants)
      } else {
        this.loadParticipants()
      }
    },
  }
</script>